import React, { useState, useEffect, memo } from "react";
import Pagination from "../../../../../components/pagination/Pagination";
import { PulseLoader } from "react-spinners";
import PlaceholderEmptyScreen from "../../../../../components/PlaceholderEmptyScreen";
import placeholderImage from "../../../../../assets/img/no-project-template.svg";
import { selectUser } from "../../../../../redux/user/user-selector";
import {
  selectIsFetchingTemplates,
  selectNumTemplates,
  selectTemplates,
  selectSelectedTemplates,
  selectSearchTemplatesQuery,
} from "../../../../../redux/templates/template-selector";
import {
  fetchTemplates,
  setSelectedTemplate,
} from "../../../../../redux/templates/template-actions";
import {
  TriyoButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../../../components/TriyoButton";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import TemplatesTableHeaderNew from "../templates-table-header/TemplatesTableHeaderNew";
import TemplateRowNew from "../templates-row/TemplateRowNew";
import AdminActionsPopupNew from "../../admin-actions-popup/AdminActionsPopupNew";

const TemplateTableContainerNew = (props) => {
  const [showAdminActionsPopup, setShowAdminActionsPopup] = useState(false);
  const [headerKey, setHeaderKey] = useState(false);
  const [isArchived, setIsArchived] = useState(false);

  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const numEntries = useSelector(selectNumTemplates);
  const data = useSelector(selectTemplates);
  const selectedRows = useSelector(selectSelectedTemplates);
  const searchQuery = useSelector(selectSearchTemplatesQuery);
  const loading = useSelector(selectIsFetchingTemplates);

  const canCreate = user?.privileges.Templates.Add;
  const containRecords = data?.length > 0;
  const canArchive = selectedRows.length > 0;

  useEffect(() => {
    refreshPage();
  }, []);

  const refreshPage = () => {
    const uID = user.profile.userID;
    setHeaderKey(!headerKey); //Will trigger component remount to reset everything in header to default state
    dispatch(
      fetchTemplates({
        userID: uID,
        pageSize: 10,
        pageNumber: 1,
        sortDesc: true,
        sortBy: "",
        filters: [],
      })
    );
    dispatch(setSelectedTemplate([]));
  };

  const changeData = (
    filters = searchQuery.filters,
    sortBy = searchQuery.sortBy,
    sortDesc = searchQuery.sortDesc
  ) => {
    dispatch(
      fetchTemplates({
        ...searchQuery,
        filters: filters,
        sortBy: sortBy,
        sortDesc: sortDesc,
      })
    );
  };

  const nextPage = () => {
    dispatch(
      fetchTemplates({ ...searchQuery, pageNumber: searchQuery.pageNumber + 1 })
    );
  };

  const prevPage = () => {
    searchQuery.pageNumber >= 1 &&
      dispatch(
        fetchTemplates({
          ...searchQuery,
          pageNumber: searchQuery.pageNumber - 1,
        })
      );
  };

  const rowChange = (numRows) => {
    dispatch(
      fetchTemplates({ ...searchQuery, pageSize: numRows, pageNumber: 1 })
    );
  };

  const onArchive = () => {
    if (!user?.privileges.Templates.Delete === false) {
      setShowAdminActionsPopup(true);
    }
  };

  const handleArchiveSuccess = () => {
    setIsArchived(true);
  };

  const renderRows = () => {
    const Rows =
      data &&
      data.map((template) => {
        return (
          <TemplateRowNew
            key={`${template.Id}_${template.ModifiedDate}`}
            data={template}
            privileges={user?.privileges}
          />
        );
      });
    return Rows;
  };

  const onClick = () => {
    history.push("/admin/templates/create");
  };

  const getSelectedName = (templateID) => {
    if (!selectedRows || selectedRows.length <= 0) {
      return "";
    }
    let selectedRow = data.filter((template) => template.Id === templateID);

    return selectedRow[0].ProjectType;
  };

  return (
    <div className="admin-panel-table-container">
      {data ? (
        <React.Fragment>
          {containRecords ? (
            <React.Fragment>
              <div className="table-control-container">
                <TriyoButton>
                  <PrimaryButton
                    onClick={onClick}
                    disabled={!canCreate}
                    text="Create New Template"
                  />
                  <SecondaryButton
                    onClick={(e) => {
                      onArchive();
                      e.preventDefault();
                    }}
                    disabled={!canArchive}
                    text="Archive"
                  />
                </TriyoButton>
                <Pagination
                  refresh={refreshPage}
                  next={nextPage}
                  prev={prevPage}
                  rowChange={rowChange}
                  numEntries={numEntries}
                  query={searchQuery}
                />
              </div>
              <div className="table-main">
                <table className="table-element">
                  <TemplatesTableHeaderNew
                    key={headerKey}
                    changeData={changeData}
                    refreshPage={refreshPage}
                    isArchived={isArchived}
                    setIsArchived={setIsArchived}
                  />
                  {!loading ? (
                    <tbody>{renderRows()}</tbody>
                  ) : (
                    <span className="pulse-loader">
                      <PulseLoader></PulseLoader>
                    </span>
                  )}
                </table>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="table-control-container">
                <TriyoButton>
                  <PrimaryButton
                    onClick={onClick}
                    disabled={!canCreate}
                    text="Create New Template"
                  />
                </TriyoButton>
              </div>
              <PlaceholderEmptyScreen
                headerText="Create a Template"
                textBeforeLink="Simplify your workflow with TRIYO. Click the "
                buttonText="Create Template"
                textAfterLink=" button to get started."
                bottomImage={placeholderImage}
                altImageText="Click to create a new template"
                onClick={() => onClick()}
              />
            </React.Fragment>
          )}
        </React.Fragment>
      ) : (
        <div className="pulse-loader">
          <PulseLoader></PulseLoader>
        </div>
      )}
      {showAdminActionsPopup && (
        <AdminActionsPopupNew
          type={"template"}
          name={selectedRows.length === 1 && getSelectedName(selectedRows[0])}
          selectedIDs={selectedRows}
          showAdminActionsPopup={showAdminActionsPopup}
          setShowAdminActionsPopup={setShowAdminActionsPopup}
          onArchiveSuccess={handleArchiveSuccess}
        />
      )}
    </div>
  );
};

export default memo(TemplateTableContainerNew);
